@if (on === 'form' && !pillField?.condensed) {
    <div class="pillFormRow">
        <ng-container [ngTemplateOutlet]="pill"></ng-container>
    </div>
}
@if (on === 'form' && pillField?.condensed) {
    <div class="condensed">
        <span class="condensed-label">{{ pillField.label }}</span>
        <span class="condensed-value">
            <ng-container [ngTemplateOutlet]="pill"></ng-container>
        </span>
        <span class="condensed-hint"></span>
    </div>
}
@if (on === 'grid') {
    <ng-container [ngTemplateOutlet]="pill"></ng-container>
}

<ng-template #pill>
    @if (iconOnly && !icon) {
    } @else if (canClick) {
        <button type="button" [attr.data-field]="pillField?.name" [class]="boxClass" [ngStyle]="boxStyle"
            [matTooltip]="tipText" (click)="onClick($event)">
            <ng-container [ngTemplateOutlet]="content"></ng-container>
        </button>
    } @else {
        <span [attr.data-field]="pillField?.name" [class]="boxClass" [ngStyle]="boxStyle" [matTooltip]="tipText">
            <ng-container [ngTemplateOutlet]="content"></ng-container>
        </span>
    }
</ng-template>

<ng-template #content>
    @if (icon) {
        <mat-icon class="pillIcon">{{ icon }}</mat-icon>
    }
    @if (!iconOnly) {
        <span>{{ text }}</span>
    }
</ng-template>
